import { useStore } from 'jotai';
import { useCallback } from 'react';

import { isCommandMenuOpenState } from '@/command-menu/states/isCommandMenuOpenState';

export const useCloseCommandMenu = () => {
  const store = useStore();

  const closeCommandMenu = useCallback(() => {
    store.set(isCommandMenuOpenState.atom, false);
  }, [store]);

  return { closeCommandMenu };
};
